import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.css']
})
export class UserAccountComponent implements OnInit {
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  permissions = [];
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email: string;
  groupList: any;
  request: any = [];

  constructor(private alertService: AlertService, private user: User, private http: HttpClient, private router: Router, private g: Globals, private api: ApiIntegration) {

    this.g.page = "Create User Account";
  }

  ngOnInit() {
  }
  typeFirstName() {
    this.statusText1 = "";
    if (this.firstName == '' || this.firstName === null || this.firstName === undefined || this.firstName === 'undefined') {
      this.statusText1 = 'Please enter first name';
    }
  }
  typeLastName() {
    this.statusText2 = "";
    if (this.lastName == '' || this.lastName === null || this.lastName === undefined || this.lastName === 'undefined') {
      this.statusText2 = 'Please enter last name';
    }
  }

  validateEmail() {
    this.g.loaderDisplay = "display";
    this.statusText4 = "";
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
          this.statusText4 = 'Please enter email address';
          this.g.loaderDisplay = "";
          return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email=' + this.email + '&userType=' + 'USER',

      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
        } else {
          if (data['code'] == 400) {
            this.statusText4 = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText4 = "uniqueEmail Failed, please re-try.";
        }
      )
  }

  validateMobile() {
    this.g.loaderDisplay = "display";
    this.statusText3 = "";
 if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText3 = 'Please enter phone number';
      this.g.loaderDisplay = "";
      return false;
    } else if (this.mobileNumber.length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
      this.g.loaderDisplay = "";
      return false;
    }
    let i = this.mobileNumber.indexOf('0');
    if (i == 0) {
      this.statusText3 = "Number should not start with 0";
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueMobileNumber',
      this.mobileNumber,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {

        } else {
          if (data['code'] == 400) {
            this.statusText3 = data['message'];
          }
        }

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText3 = "mobile number  exists";
        }
      )
  }

  submit() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";


    if (this.firstName == '' || this.firstName === null || this.firstName === undefined || this.firstName === 'undefined') {
      this.statusText1 = 'Please enter first name';
    }
    if (this.lastName == '' || this.lastName === null || this.lastName === undefined || this.lastName === 'undefined') {
      this.statusText2 = 'Please enter last name';
    }
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText3 = 'Please enter phone number';
    } else if (this.mobileNumber.length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
    }
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText4 = 'Please enter email address';
    }

    if (this.statusText1 != "" || this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/createAccountOwnerUsers', {

      "accountOwnerId": this.user.accountOwnerId,
      "email": this.email,
      "firstName": this.firstName,
      "lastName": this.lastName,
      "mobile": this.mobileNumber,
      "organizationId": "1"
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.g.loaderDisplay = "";
          this.alertService.success('User', 'Created successfully');
          this.g.pageTab = 'manageUsers';
          this.router.navigate(['/admin/myAccountList']);
        }
        else {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  createSecurityConfigs(jhiUserId, ownerId) {
    this.g.loaderDisplay = "display";
    for (let i = 0; i < this.groupList.length; i++) {
      for (let j = 0; j < this.groupList[i].securityTypes.length; j++) {
        if (this.groupList[i].securityTypes[j].status === 'ACTIVE') {
          this.request.push({
            "accessStatus": "GRANTED",
            "accountOwnerId": ownerId,
            "organizationId": 1,
            "securityTypeId": this.groupList[i].securityTypes[j].securityTypeId,
            "userId": jhiUserId
          });
        }
      }
    }

    let body = {
      "accountOwnerId": ownerId,
      "organizationId": 1,
      "createAppSecurityConfigRequestList": this.request
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/createSecurityConfig', body,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('User', 'Created successfully');
          this.router.navigate(['/admin/myAccountList']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
        //this.tabClicked === 'manageUsers'
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  allStatusChange(role) {
    if (role.enableAll && role.securityTypes.length) {
      for (let i = 0; i < role.securityTypes.length; i++) {
        if (!role.securityTypes[i].enabled) {
          role.securityTypes[i].enabled = true;
          this.statusChange(role.securityTypes[i]);
        }
      }
    }
    else {
      for (let j = 0; j < role.securityTypes.length; j++) {
        if (role.securityTypes[j].enabled) {
          role.securityTypes[j].enabled = false;
          this.statusChange(role.securityTypes[j]);
        }
      }
    }
  }

  statusChange(action, role: any = {}, i = '') {
    if (action.enabled) {
      action.status = 'ACTIVE';
      if (i !== '') {
        if (!this.groupList[i]['enableAll']) {
          let x = 0;
          role.securityTypes.forEach((s) => {
            if (s.enabled) {
              x = x + 1;
            }
          });
          if (x === role.securityTypes.length) {
            this.groupList[i].enableAll = true;
          }
        }
      }
    } else {
      if (i !== '') {
        if (this.groupList[i]['enableAll']) {
          this.groupList[i].enableAll = false;
        }
      }
      action.status = 'IN_ACTIVE';
    }
  }

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }

}


